<template>
    <b-card>
        <b-row class="ml-1 mt-4 mb-4">
            <b-col/>
            <b-col md="2">
                <b-form-input class="black" v-model="work_name" placeholder="Standart Stammauftrag" disabled></b-form-input>
            </b-col>
            <b-col class="justify-content-end" md="auto">
                <b-button v-on:click="submit" variant="primary" :disabled="au_selected.length === 0" class="px-4 mr-3">Speichern</b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col style="height:60vh; overflow: auto">
                <b-table striped hover selectable :items="augr" :fields="augr_fields"
                         select-mode="single"
                         selectedVariant="primary"
                         @row-selected="rowSelectedGroupAugr"
                ></b-table>
            </b-col>
            <b-col style="height: 60vh; overflow: auto">
                <b-table striped hover :items="au" :fields="au_fields" selectable
                         select-mode="single"
                         selectedVariant="primary"
                         @row-selected="rowSelectedObjectAugr"></b-table>
            </b-col>
        </b-row>
    </b-card>
</template>
<script>
    import {Server_URL} from "../../shared/utils";

    export default {
        name: "DefaultTask",

        data() {
            return {
                currentAugr: {},
                augr: [],
                au: undefined,
                auMap: {},
                augr_fields: [{key: "s_value", label: 'Auftragsgruppe'}],
                au_fields: [{key: "s_value", label: 'Auftrag'}],
                au_selected: [],
                work_name: ""
            }
        },
        mounted() {
            this.showLoader();
            this.$http.get(
                Server_URL+'/baumkontrolle/config/schluessel_task'
            ).then(this.responseOkGet, this.responseError)
        },
        methods: {
            rowSelectedGroupAugr(items) {
                if (items.length === 0) {
                    this.au = undefined;
                    this.au_selected = [];
                    this.currentAugr = {};
                } else {
                    this.au = this.auMap[items[0].s_value];
                    this.currentAugr = items[0];
                    this.au_selected = [];
                }
            },
            rowSelectedObjectAugr(items) {
                this.au_selected = items;
            },
            showLoader() {
                this.loader = this.$loading.show();
            },
            hideLoader() {
                if (this.loader !== undefined) {
                    this.loader.hide();
                    this.loader = undefined;
                }
            },
            responseOkGet(response) {
                this.hideLoader();
                if (response.status === 200) {
                    console.log(response);
                    this.augr = response.body.augr;
                    this.auMap = response.body.augr_map;
                    let defaultTask = response.body.default_task;
                    if (defaultTask !== null && defaultTask !== undefined && defaultTask.length !== 0) {
                        this.work_name = defaultTask[0].s_value_3;
                    }
                } else {
                    console.log(response);
                }
            },
            responseOk(response) {
                this.hideLoader();
                if (response.status === 200) {
                   this.work_name = this.au_selected[0].s_value;
                } else {
                    console.log(response);
                }
            },
            responseError(response) {
                this.hideLoader();
                if (response.status === 401) {
                    console.log(response);
                } else {
                    console.log(response);
                }
            },
            submit() {
                this.showLoader();
                this.$http.post(
                    Server_URL+'/baumkontrolle/config/schluessel',
                    {
                        s_type: "def_konto",
                        s_value: this.currentAugr.s_value_2,
                        s_value_2: this.au_selected[0].s_value_2,
                        s_value_3: this.au_selected[0].s_value,
                        is_active: true,
                    }
                ).then(this.responseOk, this.responseError);
            }
        }
    }
</script>

<style>
    .black {
        color: #000;
    }
</style>
<style scoped>

</style>
